import React, { useEffect, useCallback, useState} from 'react';
import AllEdges from "components/pulled/AllEdges.js";
import {useKeyShortcuts} from './useKeyShortcuts.js';
import {useEffectKeys} from './useEffectKeys.js';
import {getPath} from "components/effects/rack/getPath.js"
import Arrow from "components/effects/rack/Arrow.js";
import {
    setBulkWindowPositions,
    setSelectedPadEdge,
    setDrawingPadEdge,
       } from 'actions/index.js';
import {connect} from 'react-redux';

const GlobalEdges = ({
    effects,
    midiEffects,
    subSequence,
    drawingEdge,
    scale,
    setWindowPositions,
    setDrawingPadEdge,
    setSelectedPadEdge,
    ...props
}) => { 
    let x1,x2,y1,y2;

    useKeyShortcuts({subSequence, setWindowPositions});

    if (drawingEdge) {
        x1 = drawingEdge.x1;
        y1 = drawingEdge.y1;
        x2 = drawingEdge.x2;
        y2 = drawingEdge.y2;
    }
    useEffectKeys({subSequence, setSelectedPadEdge});

    useEffect(() => {
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, []);

    const onMouseMove = useCallback((e) => {
        let {sequencerEngine} = subSequence;
        let {state} = sequencerEngine;
        let {drawingEdges} = state.pads;
        if (drawingEdges[subSequence.id]) {
            let rect = props.containerRef.current.getBoundingClientRect();
            let x = e.clientX - rect.left;
            let y = e.clientY - rect.top;
            setDrawingPadEdge(
                subSequence.id,
                {
                ... drawingEdges[subSequence.id],
                x2: x,
                y2: y
            });
        }
    }, []);

    const onMouseUp = useCallback((e) => {
        setDrawingPadEdge(subSequence.id, undefined);
    }, []);

    return (<svg
              onMouseDown={(e) => setSelectedPadEdge(undefined)}
              style={{transform: 'scale('+ (1/scale) + ')'}} className="edges-drawer">
              <marker id="arrowhead" markerWidth="10" markerHeight="8" 
	              refX="4" refY="2" orient="auto">
                <polygon points="0 0, 5 2, 0 4" />
              </marker>
              {drawingEdge && <Arrow className="pad-effect-edge" points={getPath(x1,y1,x2,y2)}/>}
              {subSequence.tracks
               .filter(t => t.effectRack && t.sequencer) 
               .map(
                  pad => <AllEdges
                           key={pad.id}
                           effects={midiEffects[pad.id]}
                           scale={scale}
                           isMidi={true}
                           fromId={pad.sequencer.id}
                           outputPrefix="effect-output-"
                           pad={pad}
                           {...props}/>)}
              {subSequence.pads.map(
                  pad => <AllEdges
                           key={pad.id}
                           effects={effects[pad.id]}
                           scale={scale}
                           pad={pad} {...props}/>)}
            </svg>
           );
}

const mapStateToProps = (state, props) => {
  return {
      drawingEdge: state.pads.drawingEdges[props.subSequence.id],
      effects: state.pads.padEffects,
      midiEffects: state.pads.trackMidiEffects
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedPadEdge: x=>dispatch(setSelectedPadEdge(x)),
      setDrawingPadEdge: (x,y)=>dispatch(setDrawingPadEdge(x,y)),
      setWindowPositions: (pos)=>dispatch(setBulkWindowPositions(pos))     
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalEdges);
